module.exports = __webpack_public_path__ + "static/media/fortem.5f3f2f9f.png";